export default "__VITE_ASSET__PVCynr2x__"